module.exports = __webpack_public_path__ + "img/improve_section_left_bottom_2.7f93a7c1.png";